/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { QaEquipmentSubCategory } from './QaEquipmentSubCategory';
import {
    QaEquipmentSubCategoryFromJSON,
    QaEquipmentSubCategoryFromJSONTyped,
    QaEquipmentSubCategoryToJSON,
} from './QaEquipmentSubCategory';
import type { UserCatalogDto } from './UserCatalogDto';
import {
    UserCatalogDtoFromJSON,
    UserCatalogDtoFromJSONTyped,
    UserCatalogDtoToJSON,
} from './UserCatalogDto';
import type { PtwRegistrationState } from './PtwRegistrationState';
import {
    PtwRegistrationStateFromJSON,
    PtwRegistrationStateFromJSONTyped,
    PtwRegistrationStateToJSON,
} from './PtwRegistrationState';
import type { RtSystemManufacturer } from './RtSystemManufacturer';
import {
    RtSystemManufacturerFromJSON,
    RtSystemManufacturerFromJSONTyped,
    RtSystemManufacturerToJSON,
} from './RtSystemManufacturer';
import type { CoordinateSystem } from './CoordinateSystem';
import {
    CoordinateSystemFromJSON,
    CoordinateSystemFromJSONTyped,
    CoordinateSystemToJSON,
} from './CoordinateSystem';
import type { PossibleActionDto } from './PossibleActionDto';
import {
    PossibleActionDtoFromJSON,
    PossibleActionDtoFromJSONTyped,
    PossibleActionDtoToJSON,
} from './PossibleActionDto';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';
import type { RtSystemCategory } from './RtSystemCategory';
import {
    RtSystemCategoryFromJSON,
    RtSystemCategoryFromJSONTyped,
    RtSystemCategoryToJSON,
} from './RtSystemCategory';
import type { Brand } from './Brand';
import {
    BrandFromJSON,
    BrandFromJSONTyped,
    BrandToJSON,
} from './Brand';
import type { QaEquipmentStateOfUse } from './QaEquipmentStateOfUse';
import {
    QaEquipmentStateOfUseFromJSON,
    QaEquipmentStateOfUseFromJSONTyped,
    QaEquipmentStateOfUseToJSON,
} from './QaEquipmentStateOfUse';
import type { ReferencingObjectDto } from './ReferencingObjectDto';
import {
    ReferencingObjectDtoFromJSON,
    ReferencingObjectDtoFromJSONTyped,
    ReferencingObjectDtoToJSON,
} from './ReferencingObjectDto';
import type { DeviceInterfaceType } from './DeviceInterfaceType';
import {
    DeviceInterfaceTypeFromJSON,
    DeviceInterfaceTypeFromJSONTyped,
    DeviceInterfaceTypeToJSON,
} from './DeviceInterfaceType';
import type { PtwQaEquipmentWithRegistrationDtoCalibrationState } from './PtwQaEquipmentWithRegistrationDtoCalibrationState';
import {
    PtwQaEquipmentWithRegistrationDtoCalibrationStateFromJSON,
    PtwQaEquipmentWithRegistrationDtoCalibrationStateFromJSONTyped,
    PtwQaEquipmentWithRegistrationDtoCalibrationStateToJSON,
} from './PtwQaEquipmentWithRegistrationDtoCalibrationState';
import type { SingleDetectorConnectorType } from './SingleDetectorConnectorType';
import {
    SingleDetectorConnectorTypeFromJSON,
    SingleDetectorConnectorTypeFromJSONTyped,
    SingleDetectorConnectorTypeToJSON,
} from './SingleDetectorConnectorType';
import type { WithSerialNumber } from './WithSerialNumber';
import {
    WithSerialNumberFromJSON,
    WithSerialNumberFromJSONTyped,
    WithSerialNumberToJSON,
} from './WithSerialNumber';
import type { PtwCommentDto } from './PtwCommentDto';
import {
    PtwCommentDtoFromJSON,
    PtwCommentDtoFromJSONTyped,
    PtwCommentDtoToJSON,
} from './PtwCommentDto';

/**
 * 
 * @export
 * @interface PtwQaEquipmentWithRegistrationDto
 */
export interface PtwQaEquipmentWithRegistrationDto {
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    commentCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    commentAttachmentsCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    lastComment?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {Array<PossibleActionDto>}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    readonly possibleActions?: Array<PossibleActionDto> | null;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    creatorUser?: UserCatalogDto;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    lastModifierUser?: UserCatalogDto;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    editingUser?: UserCatalogDto;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    editingTime?: string | null;
    /**
     * 
     * @type {Array<PtwCommentDto>}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    comments?: Array<PtwCommentDto> | null;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    isReferenced?: boolean;
    /**
     * 
     * @type {Array<ReferencingObjectDto>}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    isReferencedBy?: Array<ReferencingObjectDto> | null;
    /**
     * 
     * @type {number}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    readonly deleterUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    readonly deletionTime?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    readonly isDeleted?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    typeSpecification?: string | null;
    /**
     * 
     * @type {RtSystemCategory}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    category: RtSystemCategory;
    /**
     * 
     * @type {RtSystemManufacturer}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    manufacturer: RtSystemManufacturer;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    model: string;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    subModel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    imageId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    isArchived?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    defaultImageId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    masterDeviceId?: string | null;
    /**
     * 
     * @type {WithSerialNumber}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    withSerialNumber?: WithSerialNumber;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    typeNumber?: string | null;
    /**
     * 
     * @type {Brand}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    brand1?: Brand;
    /**
     * 
     * @type {SingleDetectorConnectorType}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    singleDetectorConnectorType?: SingleDetectorConnectorType;
    /**
     * 
     * @type {DeviceInterfaceType}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    deviceInterfaceType?: DeviceInterfaceType;
    /**
     * 
     * @type {boolean}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    readonly isIotDevice?: boolean;
    /**
     * 
     * @type {QaEquipmentSubCategory}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    subCategory: QaEquipmentSubCategory;
    /**
     * 
     * @type {CoordinateSystem}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    coordinateSystem?: CoordinateSystem;
    /**
     * 
     * @type {QaEquipmentStateOfUse}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    state?: QaEquipmentStateOfUse;
    /**
     * 
     * @type {boolean}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    isRegistrable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    isCalibratable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    isZeroMeasurementConfigurable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    serialNumber: string;
    /**
     * 
     * @type {PtwRegistrationState}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    registrationState?: PtwRegistrationState;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    registrationTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    deRegistrationTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    calibrationCertificateNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    calibrationDate?: string | null;
    /**
     * 
     * @type {PtwQaEquipmentWithRegistrationDtoCalibrationState}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    calibrationState?: PtwQaEquipmentWithRegistrationDtoCalibrationState | null;
    /**
     * 
     * @type {string}
     * @memberof PtwQaEquipmentWithRegistrationDto
     */
    $type?: PtwQaEquipmentWithRegistrationDtoTypeEnum;
}


/**
 * @export
 */
export const PtwQaEquipmentWithRegistrationDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDeviceComponentDtoPtwQaEquipmentWithRegistrationDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.PtwQaEquipmentWithRegistrationDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type PtwQaEquipmentWithRegistrationDtoTypeEnum = typeof PtwQaEquipmentWithRegistrationDtoTypeEnum[keyof typeof PtwQaEquipmentWithRegistrationDtoTypeEnum];



/**
 * Check if a given object implements the PtwQaEquipmentWithRegistrationDto interface.
 */
export function instanceOfPtwQaEquipmentWithRegistrationDto(value?: unknown): value is PtwQaEquipmentWithRegistrationDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(PtwQaEquipmentWithRegistrationDtoTypeEnum)[0];
}

export function PtwQaEquipmentWithRegistrationDtoFromJSON(json: any): PtwQaEquipmentWithRegistrationDto {
    return PtwQaEquipmentWithRegistrationDtoFromJSONTyped(json, false);
}

export function PtwQaEquipmentWithRegistrationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PtwQaEquipmentWithRegistrationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': json['creationTime'] == null ? undefined : json['creationTime'],
        'creatorUserId': json['creatorUserId'] == null ? undefined : json['creatorUserId'],
        'lastModificationTime': json['lastModificationTime'] == null ? undefined : json['lastModificationTime'],
        'lastModifierUserId': json['lastModifierUserId'] == null ? undefined : json['lastModifierUserId'],
        'commentCount': json['commentCount'] == null ? undefined : json['commentCount'],
        'commentAttachmentsCount': json['commentAttachmentsCount'] == null ? undefined : json['commentAttachmentsCount'],
        'lastComment': json['lastComment'] == null ? undefined : json['lastComment'],
        'isAvailable': json['isAvailable'] == null ? undefined : json['isAvailable'],
        'origin': json['origin'] == null ? undefined : EntityOriginFromJSON(json['origin']),
        'possibleActions': json['possibleActions'] == null ? undefined : ((json['possibleActions'] as Array<any>).map(PossibleActionDtoFromJSON)),
        'creatorUser': json['creatorUser'] == null ? undefined : UserCatalogDtoFromJSON(json['creatorUser']),
        'lastModifierUser': json['lastModifierUser'] == null ? undefined : UserCatalogDtoFromJSON(json['lastModifierUser']),
        'editingUser': json['editingUser'] == null ? undefined : UserCatalogDtoFromJSON(json['editingUser']),
        'editingTime': json['editingTime'] == null ? undefined : json['editingTime'],
        'comments': json['comments'] == null ? undefined : ((json['comments'] as Array<any>).map(PtwCommentDtoFromJSON)),
        'attachments': json['attachments'] == null ? undefined : ((json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'isReferenced': json['isReferenced'] == null ? undefined : json['isReferenced'],
        'isReferencedBy': json['isReferencedBy'] == null ? undefined : ((json['isReferencedBy'] as Array<any>).map(ReferencingObjectDtoFromJSON)),
        'deleterUserId': json['deleterUserId'] == null ? undefined : json['deleterUserId'],
        'deletionTime': json['deletionTime'] == null ? undefined : json['deletionTime'],
        'isDeleted': json['isDeleted'] == null ? undefined : json['isDeleted'],
        'name': json['name'],
        'iuid': json['iuid'] == null ? undefined : json['iuid'],
        'description': json['description'] == null ? undefined : json['description'],
        'typeSpecification': json['typeSpecification'] == null ? undefined : json['typeSpecification'],
        'category': RtSystemCategoryFromJSON(json['category']),
        'manufacturer': RtSystemManufacturerFromJSON(json['manufacturer']),
        'model': json['model'],
        'subModel': json['subModel'] == null ? undefined : json['subModel'],
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'isArchived': json['isArchived'] == null ? undefined : json['isArchived'],
        'defaultImageId': json['defaultImageId'] == null ? undefined : json['defaultImageId'],
        'masterDeviceId': json['masterDeviceId'] == null ? undefined : json['masterDeviceId'],
        'withSerialNumber': json['withSerialNumber'] == null ? undefined : WithSerialNumberFromJSON(json['withSerialNumber']),
        'typeNumber': json['typeNumber'] == null ? undefined : json['typeNumber'],
        'brand1': json['brand1'] == null ? undefined : BrandFromJSON(json['brand1']),
        'singleDetectorConnectorType': json['singleDetectorConnectorType'] == null ? undefined : SingleDetectorConnectorTypeFromJSON(json['singleDetectorConnectorType']),
        'deviceInterfaceType': json['deviceInterfaceType'] == null ? undefined : DeviceInterfaceTypeFromJSON(json['deviceInterfaceType']),
        'isIotDevice': json['isIotDevice'] == null ? undefined : json['isIotDevice'],
        'subCategory': QaEquipmentSubCategoryFromJSON(json['subCategory']),
        'coordinateSystem': json['coordinateSystem'] == null ? undefined : CoordinateSystemFromJSON(json['coordinateSystem']),
        'state': json['state'] == null ? undefined : QaEquipmentStateOfUseFromJSON(json['state']),
        'isRegistrable': json['isRegistrable'] == null ? undefined : json['isRegistrable'],
        'isCalibratable': json['isCalibratable'] == null ? undefined : json['isCalibratable'],
        'isZeroMeasurementConfigurable': json['isZeroMeasurementConfigurable'] == null ? undefined : json['isZeroMeasurementConfigurable'],
        'serialNumber': json['serialNumber'],
        'registrationState': json['registrationState'] == null ? undefined : PtwRegistrationStateFromJSON(json['registrationState']),
        'registrationTime': json['registrationTime'] == null ? undefined : json['registrationTime'],
        'deRegistrationTime': json['deRegistrationTime'] == null ? undefined : json['deRegistrationTime'],
        'calibrationCertificateNumber': json['calibrationCertificateNumber'] == null ? undefined : json['calibrationCertificateNumber'],
        'calibrationDate': json['calibrationDate'] == null ? undefined : json['calibrationDate'],
        'calibrationState': json['calibrationState'] == null ? undefined : PtwQaEquipmentWithRegistrationDtoCalibrationStateFromJSON(json['calibrationState']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function PtwQaEquipmentWithRegistrationDtoToJSON(value?: Omit<PtwQaEquipmentWithRegistrationDto, 'creationTime'|'creatorUserId'|'lastModifierUserId'|'possibleActions'|'deleterUserId'|'deletionTime'|'isDeleted'|'isIotDevice'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'lastModificationTime': value['lastModificationTime'],
        'commentCount': value['commentCount'],
        'commentAttachmentsCount': value['commentAttachmentsCount'],
        'lastComment': value['lastComment'],
        'isAvailable': value['isAvailable'],
        'origin': EntityOriginToJSON(value['origin']),
        'creatorUser': UserCatalogDtoToJSON(value['creatorUser']),
        'lastModifierUser': UserCatalogDtoToJSON(value['lastModifierUser']),
        'editingUser': UserCatalogDtoToJSON(value['editingUser']),
        'editingTime': value['editingTime'],
        'comments': value['comments'] == null ? undefined : ((value['comments'] as Array<any>).map(PtwCommentDtoToJSON)),
        'attachments': value['attachments'] == null ? undefined : ((value['attachments'] as Array<any>).map(FileMetaInfoDtoToJSON)),
        'isReferenced': value['isReferenced'],
        'isReferencedBy': value['isReferencedBy'] == null ? undefined : ((value['isReferencedBy'] as Array<any>).map(ReferencingObjectDtoToJSON)),
        'name': value['name'],
        'iuid': value['iuid'],
        'description': value['description'],
        'typeSpecification': value['typeSpecification'],
        'category': RtSystemCategoryToJSON(value['category']),
        'manufacturer': RtSystemManufacturerToJSON(value['manufacturer']),
        'model': value['model'],
        'subModel': value['subModel'],
        'imageId': value['imageId'],
        'isArchived': value['isArchived'],
        'defaultImageId': value['defaultImageId'],
        'masterDeviceId': value['masterDeviceId'],
        'withSerialNumber': WithSerialNumberToJSON(value['withSerialNumber']),
        'typeNumber': value['typeNumber'],
        'brand1': BrandToJSON(value['brand1']),
        'singleDetectorConnectorType': SingleDetectorConnectorTypeToJSON(value['singleDetectorConnectorType']),
        'deviceInterfaceType': DeviceInterfaceTypeToJSON(value['deviceInterfaceType']),
        'subCategory': QaEquipmentSubCategoryToJSON(value['subCategory']),
        'coordinateSystem': CoordinateSystemToJSON(value['coordinateSystem']),
        'state': QaEquipmentStateOfUseToJSON(value['state']),
        'isRegistrable': value['isRegistrable'],
        'isCalibratable': value['isCalibratable'],
        'isZeroMeasurementConfigurable': value['isZeroMeasurementConfigurable'],
        'serialNumber': value['serialNumber'],
        'registrationState': PtwRegistrationStateToJSON(value['registrationState']),
        'registrationTime': value['registrationTime'],
        'deRegistrationTime': value['deRegistrationTime'],
        'calibrationCertificateNumber': value['calibrationCertificateNumber'],
        'calibrationDate': value['calibrationDate'],
        'calibrationState': PtwQaEquipmentWithRegistrationDtoCalibrationStateToJSON(value['calibrationState']),
        '$type': value['$type'],
    });
}

